<template>
  <section class="faq">
    <div class="faq__container">
      <h3 class="faq__title">FAQ</h3>

      <ul class="faq__list" role="list">
        <li
          v-for="(q, i) in faqs"
          :key="q.title"
          class="faq__item"
          :class="{ 'faq__item-last': i === faqs?.length - 1 }"
        >
          <button
            class="faq__btn"
            :aria-expanded="isOpen(i)"
            :aria-controls="'faq-panel-' + i"
            :class="{ 'faq__btn-open': isOpen(i) }"
            @click="toggle(i)"
          >
            <span class="faq__list-text">{{ q.title }}</span>
            <span class="faq__chevron" :class="{ 'is-open': isOpen(i) }"
              ><svg
                width="33"
                height="33"
                viewBox="0 0 33 33"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <mask
                  id="mask0_925_355"
                  style="mask-type: alpha"
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="33"
                  height="33"
                >
                  <rect
                    x="0.912109"
                    y="0.5"
                    width="32"
                    height="32"
                    fill="#D9D9D9"
                  />
                </mask>
                <g mask="url(#mask0_925_355)">
                  <path
                    d="M16.9133 20.5718L9.375 13.0334L10.78 11.6284L16.9133 17.7618L23.0467 11.6284L24.4517 13.0334L16.9133 20.5718Z"
                    fill="black"
                  />
                </g>
              </svg>
            </span>
          </button>

          <transition
            name="faq-slide"
            @enter="onEnter"
            @after-enter="onAfterEnter"
            @leave="onLeave"
          >
            <div
              v-if="isOpen(i)"
              :id="'faq-panel-' + i"
              class="faq__panel"
              role="region"
              :aria-labelledby="'faq-btn-' + i"
            >
              <p class="faq__text" v-html="q.description"></p>
            </div>
          </transition>
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
export default {
  name: "talent-faq",
  data() {
    return {
      open: [],

      faqs: [
        {
          title: "Які вікові обмеження?",
          description:
            "Ми працюємо лише з повнолітніми акторами, тому вам має виповнитися 18 років.",
        },
        {
          title: "Яка вартість розміщення?",
          description:
            "Pеєстрація на платформі передбачає річну підписку вартістю 800 грн/рік, тобто 67 грн/місяць. Оплата здійснюється під час реєстрації у студії. Зйомка входить в вартість підписки.",
        },
        {
          title: "Коли анкета з’явиться на сайті?",
          description:
            "Ваша анкета зʼявиться на сайті протягом 3–5 робочих днів після зйомки.",
        },
        {
          title: "Чи можу додати свої фото?",
          description:
            "Так, в особистому кабінеті можна додати фото та посилання на ютуб ролики.",
        },
        {
          title: "Чи можу відмовитись від кастингу?",
          description:
            "Так, після ознайомлення з деталями та умовами кастингу ти можеш відмовитись.",
        },
        {
          title: "Скільки кастингів буде?",
          description: "Залежить від запитів і твого типажу.",
        },
      ],
    }
  },
  created() {
    this.open = this.faqs.map((_, i) => 0 === i)
  },

  methods: {
    isOpen(i) {
      return !!this.open[i]
    },
    toggle(i) {
      this.$set(this.open, i, !this.open[i])
    },

    onEnter(el) {
      el.style.height = "0px"
      el.style.opacity = "0"
      el.style.overflow = "hidden"
      void el.offsetHeight
      el.style.transition =
        "height 220ms ease, opacity 220ms ease, padding 220ms ease"
      const computed = getComputedStyle(el)
      const padTop = computed.paddingTop
      const padBottom = computed.paddingBottom
      el.style.paddingTop = padTop
      el.style.paddingBottom = padBottom
      el.style.height = `${el.scrollHeight}px`
      el.style.opacity = "1"
    },
    onAfterEnter(el) {
      el.style.height = "auto"
      el.style.transition = ""
      el.style.overflow = ""
    },
    onLeave(el) {
      el.style.height = `${el.scrollHeight}px`
      el.style.opacity = "1"
      el.style.overflow = "hidden"
      void el.offsetHeight
      el.style.transition =
        "height 220ms ease, opacity 220ms ease, padding 220ms ease"
      el.style.height = "0px"
      el.style.opacity = "0"
    },
  },
}
</script>

<style lang="scss" scoped>
.faq {
  max-width: 1440px;
  width: 100%;
  margin: 0 auto;
  padding: 0 80px 160px;

  &__container {
    display: flex;
    justify-content: space-between;
  }
}
.faq__title {
  font-family: "Inter", sans-serif;

  font-size: 60px;
  font-weight: 500;
  line-height: 60px;
  letter-spacing: -0.02em;
}

.faq__list {
  display: grid;
  row-gap: 24px;
  &-text {
    font-family: "Inter", sans-serif;

    font-size: 26px;
    font-weight: 500;
    letter-spacing: -0.02em;
  }
}
.faq__item {
  border-bottom: 1px solid #0000004d;
  overflow: hidden;
  width: 628px;
}

.faq__item-last {
  border-bottom: none;
}
.faq__btn {
  width: 100%;
  background: #fff;
  border: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 16px;
  text-align: left;
  cursor: pointer;
  padding-bottom: 24px;
  font-family: "Inter", sans-serif;
  transition: all 0.3s ease;
  color: #000 !important;
  background: transparent;
  border: 0;
  -webkit-appearance: none;
  appearance: none;
  font: inherit;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  &-open {
    padding-bottom: 8px;
  }
}

.faq__chevron {
  height: 33px;
  margin-bottom: -3px;
  transition: transform 0.2s ease;
}
.faq__chevron.is-open {
  transform: rotate(180deg);
}

.faq__panel {
  transition: transform all 0.3;
}
.faq__text {
  line-height: 1.5;
  font-size: 20px;
  padding-bottom: 24px;
  font-family: "Inter", sans-serif;
}

@media (max-width: 1024px) {
  .faq {
    padding: 0 24px 121px;
  }
}

@media (max-width: 820px) {
  .faq {
    padding: 0 24px 121px;
    &__container {
      flex-direction: column;
    }

    &__list {
      margin-top: 32px;
      &-text {
        font-size: 20px;
        font-weight: 400;
      }
    }

    &__item {
      width: 100%;
    }
    &__title {
      font-size: 36px;
      line-height: 36px;
    }

    &__text {
      font-size: 16px;
      font-weight: 400;
    }
  }
}
</style>
